import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './footer.css'

const Footer = () => {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState(null) // null | 'loading' | 'success' | 'error'

  const handleSubscribe = async (e) => {
    e.preventDefault()
    if (!email) return
    setStatus('loading')
    try {
      const res = await fetch('https://formsubmit.co/ajax/admin@dataflows.com.au', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          _subject: 'New Newsletter Subscriber',
          email,
          _template: 'box',
        }),
      })
      if (res.ok) {
        setStatus('success')
        setEmail('')
      } else {
        setStatus('error')
      }
    } catch {
      setStatus('error')
    }
  }

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-section footer-section-large">
          <h3 className="footer-heading">Subscribe to our newsletter</h3>
          <form className="footer-subscription-form" onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Enter your email"
              className="footer-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button className="footer-subscribe-button" type="submit" disabled={status === 'loading'}>
              {status === 'loading' ? 'Sending…' : 'Subscribe'}
            </button>
          </form>
          {status === 'success' && <p className="footer-subscribe-msg footer-subscribe-success">Thanks for subscribing!</p>}
          {status === 'error' && <p className="footer-subscribe-msg footer-subscribe-error">Something went wrong. Please try again.</p>}
          <div className="footer-contact-info">
            <h3 className="footer-heading">Contact</h3>
            <a href="mailto:support@dataflows.com.au" className="footer-link">
              support@dataflows.com.au
            </a>
          </div>
        </div>
        <div className="footer-section">
          <h4 className="footer-heading">Solutions</h4>
          <a href="/#features" className="footer-link">Bulk SMS</a>
          <a href="/#features" className="footer-link">SMS API</a>
          <a href="/#features" className="footer-link">Two-Factor Authentication</a>
          <a href="/#features" className="footer-link">SMS Reminders</a>
          <a href="/#features" className="footer-link">Branded SMS</a>
          <Link to="/developers" className="footer-link">Developers</Link>
        </div>
        <div className="footer-section">
          <h4 className="footer-heading">Company</h4>
          <Link to="/about" className="footer-link">About</Link>
          <Link to="/blog" className="footer-link">Blog</Link>
        </div>
        <div className="footer-section">
          <h4 className="footer-heading">Legal</h4>
          <Link to="/terms-of-use" className="footer-link">Terms of Use</Link>
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
          <Link to="/sms-compliance" className="footer-link">SMS Compliance</Link>
          <Link to="/sender-id-registration" className="footer-link">Sender ID Registration</Link>
          <Link to="/contact-us" className="footer-link">Contact Us</Link>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-branding">
          <img
            alt="DataFlows Logo"
            src="/dataflows-high-resolution-logo-200h.png"
            className="footer-logo"
          />
          <p className="footer-copyright">Copyright © DataFlows, {new Date().getFullYear()}</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer 